import { Component } from '@angular/core';
import { ClientTaskHistoryItemTypeBaseComponent } from '../client-task-history-item-type-base/client-task-history-item-type-base.component';
import { ClientTaskHistoryItemTitleComponent } from '../client-task-history-item-title/client-task-history-item-title.component';
import { ClientTaskHistoryItemBodyComponent } from '../client-task-history-item-body/client-task-history-item-body.component';

@Component({
    selector: 'app-client-task-history-item-type-created',
    templateUrl: './client-task-history-item-type-created.component.html',
    imports: [ClientTaskHistoryItemTitleComponent, ClientTaskHistoryItemBodyComponent]
})
export class ClientTaskHistoryItemTypeCreatedComponent extends ClientTaskHistoryItemTypeBaseComponent {
  get title() {
    return 'Created';
  }

  get description() {
    return `New ${this.taskName.toLowerCase()} task Created`;
  }
}
